import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'skill',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    env () {
      return this.$store.getters.env
    },
    api () {
      return this.$store.getters.api
    },
    user () {
      return this.$store.getters.user
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      list: [],
      loading: true,
      updating: false,
      orderOptions: [
        { text: '新着順', value: 1 }
      ],
      orderSelect: 1,
      skillCheckerStatus: 0,
      total_count: 0
    }
  },
  mounted () {
    this.onInit()
  },
  methods: {
    onInit () {
      this.loading = true

      let additionalParams = {
        queryParams: {
          type: 'list'
        }
      }

      this.$apig.get(this.api.SKILL, {}, additionalParams, {})
        .then(response => {
          this.list = response.data.list
          this.skillCheckerStatus = response.data.skillCheckerStatus
          this.total_count = response.data.total_count
          this.loading = false
        })
    },
    apply () {
      this.updating = true

      let additionalParams = {
        queryParams: {
          type: 'skillChecker'
        }
      }

      this.$apig.patch(this.api.ENTERPRISE, {}, additionalParams, {})
        .then(response => {
          this.skillCheckerStatus = 1
          this.updating = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/skill/skill.js